import { AppEntitlementValue } from 'lib/actions/apps/app-entitlement'

export * from './EntitlementSlugWithFetch'
export * from './C1EntitlementDisplayName'
export * from './C1EntitlementDisplayNameWithFetch'

export const getEntitlementDisplayName = (entitlement: AppEntitlementValue): string => {
    if (entitlement.slug) {
        if (entitlement.systemBuiltin && entitlement.app) {
            return entitlement.app.displayName
        }
        if (entitlement.appResource) {
            return entitlement.appResource.displayName
        }
    }
    return entitlement.displayName
}

export const getEntitlementDisplayNameTextOnly = (entitlement: AppEntitlementValue): string => {
    const displayName = getEntitlementDisplayName(entitlement)
    return entitlement.slug ? `${displayName} / ${entitlement.slug}` : displayName
}
